// @ts-nocheck

class Tooltip extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.isMobile = this.checkMobile();
    this.tooltip = null;
  }

  checkMobile() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      window.matchMedia('(max-width: 768px)').matches
    );
  }

  connectedCallback() {
    this.createTooltip();
    this.attachEvents();
  }

  createTooltip() {
    const template = this.querySelector('template');
    if (!template) return;

    this.tooltip = document.createElement('div');
    this.tooltip.className = 'tooltip-content';
    this.tooltip.innerHTML = template.innerHTML;
    this.tooltip.style.cssText = `
      position: fixed;
      z-index: 10000;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s;
      display: none;
      max-width: ${this.isMobile ? '90dvw' : '500px'};
      width: fit-content;
    `;

    this.arrow = document.createElement('div');
    this.arrow.className = 'tooltip-arrow';
    this.arrow.style.cssText = `
      position: absolute;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    `;
    this.tooltip.appendChild(this.arrow);

    document.body.appendChild(this.tooltip);
  }

  positionTooltip() {
    if (!this.tooltip) return;

    const triggerRect = this.getBoundingClientRect();
    const tooltipRect = this.tooltip.getBoundingClientRect();

    const spacing = 8;
    let top, left;
    let position = 'top';
    if (triggerRect.top - tooltipRect.height - spacing > 0) {
      position = 'top';
      top = triggerRect.top - tooltipRect.height - spacing;
      left = triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2;
    } else if (window.innerHeight - triggerRect.bottom - spacing > tooltipRect.height) {
      position = 'bottom';
      top = triggerRect.bottom + spacing;
      left = triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2;
    } else {
      if (triggerRect.left > window.innerWidth / 2) {
        position = 'left';
        top = triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2;
        left = triggerRect.left - tooltipRect.width - spacing;
      } else {
        position = 'right';
        top = triggerRect.top + triggerRect.height / 2 - tooltipRect.height / 2;
        left = triggerRect.right + spacing;
      }
    }

    if (left < spacing) left = spacing;
    if (left + tooltipRect.width > window.innerWidth - spacing) {
      left = window.innerWidth - tooltipRect.width - spacing;
    }

    this.tooltip.style.top = `${top}px`;
    this.tooltip.style.left = `${left}px`;

    this.positionArrow(position, triggerRect, tooltipRect, left, top);
  }

  positionArrow(position, triggerRect, tooltipRect, tooltipLeft, tooltipTop) {
    if (position === 'top') {
      this.arrow.style.cssText = `
        position: absolute;
        top: 100%;
        left: ${triggerRect.left + triggerRect.width / 2 - tooltipLeft}px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #fff;
      `;
    } else if (position === 'bottom') {
      this.arrow.style.cssText = `
        position: absolute;
        bottom: 100%;
        left: ${triggerRect.left + triggerRect.width / 2 - tooltipLeft}px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
      `;
    } else if (position === 'left') {
      this.arrow.style.cssText = `
        position: absolute;
        left: 100%;
        top: ${triggerRect.top + triggerRect.height / 2 - tooltipTop}px;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid #fff;
      `;
    } else if (position === 'right') {
      this.arrow.style.cssText = `
        position: absolute;
        right: 100%;
        top: ${triggerRect.top + triggerRect.height / 2 - tooltipTop}px;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 6px solid #fff;
      `;
    }
  }

  attachEvents() {
    if (this.isMobile) {
      this.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle();
      });

      document.addEventListener('click', () => {
        if (this.isOpen) {
          this.hide();
        }
      });
    } else {
      this.addEventListener('mouseenter', () => {
        this.show();
      });

      this.addEventListener('mouseleave', () => {
        this.hide();
      });
    }
  }

  show() {
    if (!this.tooltip) return;
    this.tooltip.style.opacity = '0';
    this.tooltip.style.pointerEvents = 'none';
    this.tooltip.style.display = 'block';

    requestAnimationFrame(() => {
      this.positionTooltip();
      this.tooltip.style.opacity = '1';
      this.tooltip.style.pointerEvents = 'auto';
    });

    this.isOpen = true;

    this.updatePosition = () => this.positionTooltip();
    window.addEventListener('scroll', this.updatePosition, true);
    window.addEventListener('resize', this.updatePosition);
  }

  hide() {
    if (!this.tooltip) return;
    this.tooltip.style.opacity = '0';
    this.tooltip.style.pointerEvents = 'none';
    this.tooltip.style.display = 'none';
    this.isOpen = false;

    if (this.updatePosition) {
      window.removeEventListener('scroll', this.updatePosition, true);
      window.removeEventListener('resize', this.updatePosition);
    }
  }

  toggle() {
    if (this.isOpen) {
      this.hide();
    } else {
      this.show();
    }
  }

  disconnectedCallback() {
    if (this.isMobile) {
      document.removeEventListener('click', this.hide);
    }

    if (this.tooltip && this.tooltip.parentNode) {
      this.tooltip.parentNode.removeChild(this.tooltip);
    }

    if (this.updatePosition) {
      window.removeEventListener('scroll', this.updatePosition);
      window.removeEventListener('resize', this.updatePosition);
    }
  }
}

if (!customElements.get('ui-tooltip')) {
  customElements.define('ui-tooltip', Tooltip);
}